import React from "react";
import type { ToastType } from "./ToastProvider";

export const ToastContext = React.createContext<{
  showToast(toast: Omit<ToastType, "id">): void;
} | null>(null);
